<template>
  <div class="signin_box">
    <div class="signin_top">
      <el-row>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 22, offset: 1 }"
          :md="{ span: 16, offset: 4 }"
          :lg="{ span: 14, offset: 5 }"
          :xl="{ span: 14, offset: 5 }"
        >
          <div class="signin_top_title">
            <img
              alt="投票、企业投票云服务、企业投票、网络投票、微信投票、会议投票"
              src="../../../assets/images/logo2_1.png"
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row class="signin_main">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div class="signin_main_container">
          <div class="signin_main_left" v-if="false">
            <div
              v-if="meetingState.IsLogin"
              class="meeting_title"
              v-html="meetingState.HtmlMeetingName"
            ></div>
          </div>
          <div class="signin_main_right">
            <div
              v-if="!meetingState.IsLogin"
              class="meeting_title"
              style="text-align: center"
            >
              <span v-if="meetingState.NoLoginType === 1">问卷不存在</span>
              <span v-if="meetingState.NoLoginType === 2">问卷未开始</span>
              <div v-if="meetingState.NoLoginType === 4">
                <span> 匿名问卷 </span>
                <!-- <el-button
                    type="primary"
                    class="signin_submit_btn"
                    v-on:click="anonymousLogin()"
                >
                    开始答卷
                </el-button> -->
              </div>
            </div>
            <div
              v-if="meetingState.IsLogin && !meetingState.IsAssignQuestionnaire"
              class="meeting_title"
              v-html="meetingState.HtmlMeetingName"
              style="text-align: center"
            ></div>
            <div
              v-if="meetingState.IsLogin && meetingState.IsAssignQuestionnaire"
              class="meeting_title"
              v-html="meetingState.QuestionnaireName"
              style="text-align: center"
            ></div>
            <div class="signin_main_form" v-if="meetingState.IsLogin">
              <h3>用户登录</h3>
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="0px"
                class="login_box_form"
              >
                <el-form-item label="" prop="username">
                  <el-input
                    type="text"
                    v-model="ruleForm.username"
                    placeholder="请输入用户名"
                    prefix-icon="el-icon-user-solid"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="" prop="password">
                  <el-input
                    type="text"
                    v-model="ruleForm.password"
                    placeholder="请输入密码"
                    prefix-icon="el-icon-lock"
                    clearable
                    show-password
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    class="signin_submit_btn"
                    v-on:click="submitForm('ruleForm')"
                  >
                    登录
                  </el-button>
                </el-form-item>
                <el-form-item>
                  <div v-if="meetingState.ContactPeople">
                    联系人：{{ meetingState.ContactPeople }}
                  </div>
                  <div v-if="meetingState.ContactPhone">
                    联系电话：{{ meetingState.ContactPhone }}
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="signin_footer">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 16, offset: 4 }"
        :lg="{ span: 14, offset: 5 }"
        :xl="{ span: 14, offset: 5 }"
      >
        <div>北京鹏宇成软件技术有限公司 提供技术支持</div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import answerPaperApi from '../../../api/wj/answerPaper'
export default {
  data () {
    return {
      meetingState: {
        IsLogin: false,
        NoLoginType: 0,
        MeetingName: '',
        IsVoteUserApply: false,
        IsGoApply: false,
        IsAssignQuestionnaire: false
      },
      ruleForm: {
        username: '',
        password: '',
        isRemember: false
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 1, max: 13, message: '长度在 1 到 13 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    getQuestionnaireLoginInfo: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getQuestionnaireLoginInfo({
        MeetingId: _this.$route.params.mid,
        QuestionnaireId: _this.$route.params.qid
      }).then(data => {
        _this.meetingState = data
        if (_this.meetingState.NoLoginType === 2) {
          // _this.anonymousLogin()
        }
        if (_this.meetingState.IsVoteUserApply) {
          if (_this.meetingState.IsGoApply) {
            // _this.$router.push({ name: 'wjUserApply', params: { mid: _this.$route.params.mid, cid: _this.$route.params.cid } })
            alert('报名功能暂不开通')
          }
        }
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    submitForm (formName) {
      const _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.openLoading()
          var params = new URLSearchParams()
          params.append('grant_type', 'password')
          params.append('login_mode', 'wj_answer')
          params.append('username', this.ruleForm.username)
          params.append('password', this.ruleForm.password)
          params.append('meeting_id', this.$route.params.mid)
          params.append('company_id', this.$route.params.cid)
          this.$api.account.login(params).then(data => {
            const saveParam = {
              token: data.access_token,
              token_type: data.token_type,
              refresh_token: data.refresh_token,
              expires_in: data.expires_in,
              issued: data['.issued'],
              expires: data['.expires'],
              role: 'wj_answer',
              rememberClient: this.ruleForm.isRemember
            }
            this.$store.commit('ADD_ACCOUNT', saveParam)
            if (_this.meetingState.IsAssignQuestionnaire) {
              _this.openAnswerPaper()
            } else {
              _this.openLoading().close()
              this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
            }
          }).catch(err => {
            window.console.log('err', err)
            _this.openLoading().close()
          })
        } else {
          window.console.log('error login!!')
          return false
        }
      })
    },
    openAnswerPaper: function () {
      const _this = this
      _this.openLoading()
      answerPaperApi.getAnswerPaperState({
        questionnaireId: _this.$route.params.qid
      }).then(data => {
        _this.openLoading().close()
        if (data.RoleId === 7) {
          _this.$router.push({ name: 'markingAnswerPaperList', params: { cid: _this.$route.params.cid, mid: _this.$route.params.mid, qid: _this.$route.params.qid, s: 'signin' } })
        } else {
          if (data.IsSubmit) {
            _this.$router.push({ name: 'completeAnswerPaper', params: { cid: _this.$route.params.cid, mid: _this.$route.params.mid, qid: _this.$route.params.qid, aid: data.AnswerPaperId, s: 'signin' } })
          } else {
            if (data.AnswerPaperId) {
              _this.$router.push({ name: 'answerPaper', params: { cid: _this.$route.params.cid, mid: _this.$route.params.mid, qid: _this.$route.params.qid, aid: data.AnswerPaperId, s: 'signin' } })
            } else {
              _this.$router.push({ name: 'answerQuestionnaireList', params: { mid: this.$route.params.mid } })
            }
          }
        }
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    openUserApply: function () {
      //   const _this = this
      //   _this.$router.push({ name: 'wjUserApply', params: { mid: _this.$route.params.mid, cid: _this.$route.params.cid } })
      alert('暂不开通')
    }
  },
  mounted () {

  },
  created () {
    this.getQuestionnaireLoginInfo()
  }
}
</script>

<style lang="less">
.signin_box {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
}
.signin_top {
  width: 100%;
  background: #3f8ef7;
  height: 60px;
  margin: 0 auto;
}
.signin_top .signin_top_title {
  font-weight: bold;
  font-size: 24px;
  color: #fff;
  height: 60px;
  padding: 0px 10px;
}
.signin_top .signin_top_title img {
  margin: 8px 0px;
  height: 45px;
}
.signin_main {
  flex-grow: 1;
  width: 100%;
  padding: 110px 0px 0px 0px;
}
.signin_main_container {
  height: 100%;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
}
.signin_main_left {
  flex-grow: 1;
  flex-shrink: 1;
}
.signin_main_right {
  flex-grow: 0;
  flex-shrink: 0;
  width: 530px;
}
.signin_main_form {
  width: 100%;
  border: 1px solid #e5e5e5;
  padding: 35px 25px 35px 25px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff;
}
.signin_footer {
  width: 100%;
  margin: 20px 0px;
  padding-top: 15px;
  text-align: center;
}
.signin_box .meeting_title {
  padding: 0px 0px 20px 0px;
  font-size: 24px;
  font-weight: 900;
}

.signin_submit_btn {
  width: 100%;
  font-size: 16px;
  letter-spacing: 10px;
  text-indent: 10px;
}
.user_apply_btn_box {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
}
</style>
